import { PlanProduct } from '../../../../types';
import { OnetimePeriod, PlanTemplateType, SubscriptionPeriod } from '../types';

/**
 * 주어진 조건에 따라 PlanProduct를 필터링하는 함수
 */
export function filterPlanProducts({
  plans,
  planTemplateType,
  maxCcu,
  subscriptionPeriod,
  onetimePeriod,
}: {
  plans: PlanProduct[];
  planTemplateType: PlanTemplateType;
  maxCcu: number;
  subscriptionPeriod?: SubscriptionPeriod;
  onetimePeriod?: OnetimePeriod;
}): PlanProduct | undefined {
  return plans?.find(plan => {
    if (planTemplateType === PlanTemplateType.PRODUCT_SUBSCRIPTION) {
      return (
        plan.maxCcu === maxCcu &&
        plan.subscriptionPeriod === Number(subscriptionPeriod)
      );
    } else if (planTemplateType === PlanTemplateType.PRODUCT_ONETIME) {
      return plan.maxCcu === maxCcu && plan.onetimePeriod === onetimePeriod;
    }
    return false;
  });
}
